<div class="row row-offcanvas row-offcanvas-left">
  <div class="sf_colsIn col-xs-6 col-sm-3 sidebar-offcanvas" id="sidebar">
    <span class="list-group-item active text-center menuoverskrift"
      >Kontakt</span
    ><br />
  </div>

  <div class="col-xs-12 col-sm-9">
    <div class="row">
      <div class="col-md-6">
        <h3>Driftsansvarlig</h3>
        <p>
          Den daglige drift af vandværket varetages af Tage Bagger A/S. Ved
          akutte situationer som f.eks. driftsstop, ledningsbrud og lignende
          kontaktes vagthavende hos Tage Bagger A/S i prioriteret rækkefølge:
        </p>
        <br />
        <table class="table table-hover">
          <tbody>
            <tr>
              <td>Tage Bagger A/S (08:00 – 15:00)</td>
              <td class="auto-style1">4818 7083</td>
            </tr>
            <tr>
              <td>Christian Bagger</td>
              <td class="auto-style1">2125 7083</td>
            </tr>
            <tr>
              <td>Per Olsen</td>
              <td class="auto-style1">4010 7083</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <div>
          <a
            href="https://www.google.dk/maps/place/I%2FS+Uggel%C3%B8se+Vandv%C3%A6rk+V%2Fjan+Bjerregaard/@55.8357381,12.2671502,15z/data=!4m2!3m1!1s0x0:0xfcc0de9226f525e6"
            target="_blank"
          >
            <p class="margin-top-10px text-center">
              <img
                class="vandFoto img-responsive img-rounded"
                src="assets/images/google_ug.jpeg"
                alt="Google Map"
              />
              <br class="text-center" /><i class="fa fa-globe fa-3x"></i><br />
            </p>
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h3>Regning og målere</h3>
        Henvendelser vedrørende regninger, måleraflæsninger og målerskift kan
        ske til vandværkets kasserer:
        <table class="table table-hover">
          <tbody>
            <tr>
              <td style="border-top: 1px solid #ffffff">Navn</td>
              <td class="auto-style1">Midtregnsskab</td>
            </tr>
            <tr>
              <td>Telefon</td>
              <td class="auto-style1">2122 4880</td>
            </tr>
            <tr>
              <td>E-mail</td>
              <td class="auto-style1">
                <a
                  style="font-weight: normal"
                  href="mailto:kontakt@midtregnskab.dk"
                  >kontakt&#64;midtregnskab.dk</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h3>Øvrige henvendelser</h3>
        <p>Øvrige henvendelser kan ske til vandværkets telefon eller mail:</p>
        <!--
      <table class="table table-hover">
        <tbody>
          <tr>
            <td style="border-top: 1px solid #ffffff;">x</td>
          </tr>
          <tr>
            <td>Telefon</td>
            <td class="auto-style1">1234 5678</td>
          </tr>
          <tr>
            <td>E-mail</td>
            <td class="auto-style1"><a style="font-weight:normal;"
                href="mailto:kasserer@uggelosevv.dk">kasserer&#64;uggelosevv.dk</a></td>
          </tr>

        </tbody>
      </table>-->
        <p>Bestyrelsen (træffes tirsdag og torsdag 19-20.30)</p>
        <table class="table table-hover">
          <tbody>
            <tr>
              <td>Telefon</td>
              <td class="auto-style1">4819 2192</td>
            </tr>
            <tr>
              <td>E-mail</td>
              <td>
                Se Bestyrelsessiden:
                <a
                  style="font-weight: normal"
                  href="https://uggelosevv.dk/om/bestyrelse"
                  >https://uggelosevv.dk/om/bestyrelse</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
